var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Row',[_c('i-col',{attrs:{"span":"22"}}),_vm._v(" "),_c('i-col',{attrs:{"span":"2"}},[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.add}},[_vm._v("新增")])],1)],1),_vm._v(" "),_c('Table',{attrs:{"context":_vm.self,"data":_vm.tableData,"columns":_vm.tableColumns,"stripe":"","border":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d168342","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/privileges/aprtmentindex.vue
// module id = null
// module chunks = 